import {useTranslation} from 'react-i18next';
import * as css from './AssignedTicketsButton.css';
import TicketLine from '../../../../../assets/icons/TicketLine';

interface AssignedTicketsButtonProps {
    count?: number;
    onClick?: () => void;
}

function AssignedTicketsButton({count = 0, onClick}: AssignedTicketsButtonProps) {
    const {t} = useTranslation('timetable');
    return (
        <css.wrapper onClick={onClick} aria-label={t('assignedTickets')}>
            <TicketLine />
            <css.badge>{count}</css.badge>
        </css.wrapper>
    );
}

export default AssignedTicketsButton;
